module.exports = __webpack_public_path__ + "media/images/application/icons/icon-card-07958f19634da6584852b77c5297ae53.svg";